<template>
  <div
    v-if="companies && $login.can('companies.view')"
    class="companies-list"
  >
    <page-header header="Companies">
      <router-link
        v-if="$login.can('companies.create')"
        :to="{ name: 'companies.create-manually' }"
        class="btn btn-primary"
      >
        Create Company
      </router-link>
    </page-header>

    <div class="mt-3">
      <search
        @input="updateSearchParam"
        class="mb-3"
      />

      <vue-good-table
        styleClass="vgt-table"
        :columns="columns"
        :rows="companies"
        @on-row-click="({row}) => onRowClick(row)"
      />

      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';

import axios from '@/axios'
import {createHttpQuery} from '@/helpers'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'
import {successNotification} from '@/notifications'

const defaultParams = {
  page: 1,
  channel_id: null,
  show_deleted: false,
  search: null,
}

export default {
  components: {
    VueGoodTable,
    Search,
    Pagination,
  },

  data () {
    const params = {
      ...defaultParams,
      ...this.$route.query,
    }

    return {
      companies: null,
      pagination: null,
      params,
      drafts: [],
      channels: [],
      loading: false,
      channel: null,
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Country',
          field: 'country.name',
        },
        {
          label: 'Sector',
          field: 'micro_sector.sector.name',
        },
        {
          label: 'Ticker',
          field: ({tickers}) => (tickers.find(t => t.data_provider_id === null) || {}).ticker
        },
      ],
    }
  },

  metaInfo () {
    return {
      title: 'Companies',
    }
  },

  created () {
    this.getData()
  },

  watch: {
    channel () {
      this.params.channel_id = this.channel.id
    },
  },

  methods: {
    async getData () {
      if (!this.loading) {
        this.loading = true
        const params = createHttpQuery(this.params)
        const {data} = await axios.get('/companies', {params})
        this.setData(data)
        this.loading = false
      }
    },

    setData (companies) {
      this.pagination = companies.meta
      this.companies = companies.data

      if (this.companies) {
        this.companies.forEach((company) => {
          company.showActions = false
        })
      }
    },

    changePage (page = 1) {
      this.params.page = page
      const {params} = this
      history.pushState({}, null, this.$router.resolve({query: {...params, page}}).href)
      this.getData()
    },

    updateSearchParam (search = '') {
      if (this.params.search != search) {
        this.params.search = search
        this.params.page = 1
        const {params} = this
        history.pushState({}, null, this.$router.resolve({query: {...params}}).href)
        this.getData()
      }
    },

    clearAll () {
      this.params.channel_id = null
    },

    confirmDelete (company) {
      this.$notify({
        group: 'confirm',
        type: 'error',
        title: 'Are you sure you want to delete ' + company.name + '?',
        data: {
          onConfirm: () => {
            this.$http.delete('/companies/' + company.id).then((response) => {
              if (!this.params.show_deleted) {
                this.companies.splice(this.companies.indexOf(company), 1)
              } else {
                this.companies[this.companies.indexOf(company)] = response.data
              }
              this.$notify(successNotification(`Deleted ${company.name}`))
            })
          },
        },
      })
    },

    restore (company) {
      this.$http
          .patch('/companies/' + company.id + '/restore')
          .then((response) => {
            this.companies[this.companies.indexOf(company)] = response.data
            this.$notify(successNotification(`Restored ${company.name}`))
          })
    },

    selectedChannel (selected) {
      this.params.channel_id = selected ? selected.object.id : null
    },

    onRowClick (company) {
      this.$router.push({
        name: 'companies.view',
        params: {
          companyId: company.id,
        },
      })
    },
  },
}
</script>
